import {
	connectBuyforyou as connectBuyforyouApi,
	fetchPricingCurrencyBuyforyou as fetchPricingCurrencyBuyforyouApi,
} from '@/assets/ts/apiManagement'

export async function useCallApi(action: any, payload: any = null) {
	const conditions = [401, 422]
	let unauthorizedTimes = 0
	let errorResponse: any = null
	const payloadBackup: any = payload ? structuredClone(payload) : null

	async function triggerAction() {
		if (unauthorizedTimes > 1) {
			return [errorResponse, null]
		}

		try {
			if (payloadBackup && payloadBackup.isTokenUnnecessary) {
				delete payloadBackup.isTokenUnnecessary
			} else {
				await connectBuyforyou()
			}
			const data = await action(payloadBackup)
			return [null, data]
		} catch (error: any) {
			if (conditions.includes(error.response.status)) {
				unauthorizedTimes += 1
				errorResponse = error
				await connectBuyforyou(true)
				return triggerAction()
			}
			return [error, null]
		}
	}

	return triggerAction()
}

export async function connectBuyforyou(isForceUpdate = false) {
	const token = localStorage.getItem(
		`tokenBuyforyou_${window.BUYANDSHIP.settings.user_id}`,
	)
	if (!token) {
		return connectBuyforyouApi()
	}
	try {
		if (isForceUpdate) {
			return await connectBuyforyouApi()
		}
	} catch (error) {
		return error
	}
}

export async function fetchPricingCurrencyBuyforyou() {
	const [error, data] = await useCallApi(fetchPricingCurrencyBuyforyouApi, {
		isTokenUnnecessary: true,
	})
	if (error) {
		throw error
	}
	return data
}
